
export { Layout }

import Chat from "aldoo-ra/Chat"
import ContactPanel from "../components/ContactPanel"
import React from "react"
import Footer from "../components/Footer"
import Navbar from "../components/Navbar"
import useSentry from "../components/SentryWrapper"
import "./Layout.css"
import AldooBoot from "aldoo-ra/Boot"
import CookieBanner from "../components/Site/CookieBanner"
import ContactPanelPartners from "../components/ContactPanelPartners"
import { usePageContext } from "vike-react/usePageContext"

function Layout({ children }) {
  // Always use pageContext for consistent SSR/client behavior
  const pageContext = usePageContext()
  const currentPath = pageContext?.urlPathname || '/'
  
  const shouldHideNavFooter =  currentPath === '/index' || 
                              currentPath?.startsWith('/admin') ||
                              currentPath?.includes('/cms') ||
                              currentPath?.startsWith('/newsletter')

  return (
    <React.StrictMode>
      <AldooBoot />
      <PageLayout>
        {/* <MicrosoftTracking /> */}
        {!shouldHideNavFooter && <Navbar />}
        <Content>{children}</Content>
        {/* <Chat /> */}
        <ContactPanel />
        <ContactPanelPartners />
        {!shouldHideNavFooter && <Footer />}
        <CookieBanner />
      </PageLayout>
    </React.StrictMode>
  )
}

function PageLayout({ children }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        maxWidth: "100%",
        margin: "auto",
      }}
    >
      {children}
    </div>
  )
}

function Content({ children }) {
  return (
    <div
      className="main-content bg-paper"
      style={{
        minHeight: "100vh",
      }}
    >
      {children}
    </div>
  )
}
